import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

function formatCellValue(value) {
  if (value == null || value === '') {
    return '—';
  }
  return String(value);
}

const RecentFormsModal = ({
  open,
  onClose,
  forms = [],
  loading = false,
  translations = {},
}) => {
  const emptyMessage =
    translations.noRecentForms ||
    'No recent forms available for this retailer.';

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='md'>
      <DialogTitle sx={{ fontFamily: 'BrightstarSans-Bold' }}>
        {translations.recentForms || 'Recent Forms'}
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0, minHeight: 200 }}>
        {loading ? (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              py: 6,
            }}
          >
            <CircularProgress size={32} sx={{ color: 'var(--reach-blue)' }} />
          </Box>
        ) : !forms.length ? (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              py: 6,
              px: 2,
            }}
          >
            <Typography
              variant='body2'
              color='text.secondary'
              sx={{ textAlign: 'center' }}
            >
              {emptyMessage}
            </Typography>
          </Box>
        ) : (
          <TableContainer>
            <Table size='small' aria-label='recent forms'>
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: 'rgba(5, 10, 48, 0.04)',
                    '& .MuiTableCell-head': {
                      fontFamily: 'BrightstarSans-Bold',
                      color: 'var(--reach-blue)',
                      borderBottomColor: 'rgba(5, 5, 51, 0.1)',
                      whiteSpace: 'nowrap',
                    },
                  }}
                >
                  <TableCell>Submission Time</TableCell>
                  <TableCell>Form Name</TableCell>
                  <TableCell>Submitter</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {forms.map((form, index) => (
                  <TableRow
                    key={form.id ?? `form-${index}`}
                    sx={{
                      '&:last-child td': { borderBottom: 0 },
                      '& .MuiTableCell-root': {
                        fontFamily: 'BrightstarSans-Regular',
                        color: 'var(--reach-blue)',
                        borderBottomColor: 'rgba(5, 5, 51, 0.1)',
                      },
                    }}
                  >
                    <TableCell>
                      {formatCellValue(form.submissionTime)}
                    </TableCell>
                    <TableCell sx={{ fontFamily: 'BrightstarSans-Bold' }}>
                      {formatCellValue(form.formName)}
                    </TableCell>
                    <TableCell>{formatCellValue(form.submitter)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{translations.close || 'Close'}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default RecentFormsModal;
